import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, } from 'recharts';
const styles = {
    container: {
        width: '100%',
    },
    noData: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '200px',
        backgroundColor: '#f9fafb',
        borderRadius: '10px',
        color: '#6b7280',
        fontSize: '14px',
    },
};
/**
 * Custom tooltip for the area chart
 */
const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (_jsxs("div", { style: {
                backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '12px',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
            }, children: [_jsx("p", { style: { margin: 0, fontWeight: 600, color: '#111827' }, children: label }), _jsxs("p", { style: { margin: '4px 0 0', color: '#6366f1' }, children: [payload[0].value.toLocaleString(), " events"] })] }));
    }
    return null;
};
export const HourlyUsageChart = ({ data, height = 200, color = '#6366f1', }) => {
    if (!data || data.length === 0) {
        return (_jsx("div", { style: styles.noData, children: "No hourly data available" }));
    }
    // Ensure we have data for all 24 hours
    const fullData = Array.from({ length: 24 }, (_, i) => {
        const hour = String(i).padStart(2, '0') + ':00';
        const existing = data.find((d) => d.hour === hour || d.hour === String(i));
        return {
            hour,
            count: existing?.count || 0,
        };
    });
    const gradientId = `hourlyGradient-${color.replace('#', '')}`;
    return (_jsx("div", { style: styles.container, children: _jsx(ResponsiveContainer, { width: "100%", height: height, children: _jsxs(AreaChart, { data: fullData, margin: { top: 10, right: 10, left: -20, bottom: 0 }, children: [_jsx("defs", { children: _jsxs("linearGradient", { id: gradientId, x1: "0", y1: "0", x2: "0", y2: "1", children: [_jsx("stop", { offset: "5%", stopColor: color, stopOpacity: 0.3 }), _jsx("stop", { offset: "95%", stopColor: color, stopOpacity: 0.05 })] }) }), _jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6", vertical: false }), _jsx(XAxis, { dataKey: "hour", tick: { fontSize: 12, fill: '#6b7280' }, tickLine: false, axisLine: { stroke: '#e5e7eb' }, interval: 2 }), _jsx(YAxis, { tick: { fontSize: 12, fill: '#6b7280' }, tickLine: false, axisLine: false, allowDecimals: false, tickFormatter: (value) => {
                            if (value >= 1000) {
                                return (value / 1000).toFixed(0) + 'k';
                            }
                            return value.toString();
                        } }), _jsx(Tooltip, { content: _jsx(CustomTooltip, {}) }), _jsx(Area, { type: "monotone", dataKey: "count", stroke: color, strokeWidth: 2, fill: `url(#${gradientId})`, dot: false, activeDot: { r: 4, fill: color, stroke: '#fff', strokeWidth: 2 } })] }) }) }));
};
export default HourlyUsageChart;
